import React, { useState, useEffect } from "react";
import { Congratulations } from "@resources";
import { useLocation, useNavigate } from 'react-router-dom';
import classNames from "classnames";
import { helpers, Enums } from "@shared";
import { sunboundPayProxy } from '@proxies';
import { useSpinnerContext } from '@contexts';

const EnrollmentCompleted = () => {

    const navigate = useNavigate(), location = useLocation();
    const { setSpinnerShow } = useSpinnerContext();
    const {
        state: {
            idProductType,
            creditChecked,
            account: { idAccount }
        }
    } = location;
    const [auto, setAuto] = useState(true);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const next = async () => {
        setSpinnerShow(true);
        try {
            await sunboundPayProxy.setSubscription(idAccount, idProductType, auto);
            helpers.navigateNext(location, navigate);
        } catch (error) {
            console.error(error);
        } finally {
            setSpinnerShow(false);
        }
    };

    let body = null;

    if (idProductType === Enums.ProductType.Gateway) {
        body = (
            <div className="flex flex-col rounded-xl shadow-sb justify-center gap-y-5 p-5">
                <span className="text-center font-bold text-xl">Use these settings every month</span>
                <span className="text-center text-gray-600">By clicking <b>Save and Finish</b> with “Yes” selected we will automatically assign these amounts to these payors each month</span>
                <div className="yesno-wrapper">
                    <button
                        type="button"
                        className={classNames(`btn text-xl btn-yesno`, { "btn-primary": auto }, { "btn-outline-primary": !auto })}
                        onClick={() => setAuto(true)}>Yes</button>
                    <button
                        type="button"
                        className={classNames(`btn text-xl btn-yesno`, { "btn-danger": !auto }, { "btn-outline-danger": auto })}
                        onClick={() => setAuto(false)}>No</button>
                </div>
            </div>
        );
    } else {

        body = (
            <div className="flex flex-col rounded-xl shadow-sb justify-center gap-y-5 p-5">
                <span className="text-center font-bold text-xl">Pay over time every month?</span>
                <span className="text-center text-gray-600">By choosing “Yes” below you are authorizing Sunbound to automatically enroll you in the flexible timeline each month. If you choose “No”, you will need to manually enroll each month</span>
                <div className="yesno-wrapper">
                    <button
                        type="button"
                        className={classNames(`btn text-xl btn-yesno`, { "btn-primary": auto }, { "btn-outline-primary": !auto })}
                        onClick={() => setAuto(true)}>Yes</button>
                    <button
                        type="button"
                        className={classNames(`btn text-xl btn-yesno`, { "btn-danger": !auto }, { "btn-outline-danger": auto })}
                        onClick={() => setAuto(false)}>No</button>
                </div>
            </div>
        );
    }

    let title;
    if (idProductType === Enums.ProductType.SunboundPay && !creditChecked)
        title = (<>
            <h1 className="page-header">Thank you!<br />Confirmation email to come</h1>
            <span className="page-subheader text-xl">Since this is your first time using Pay Over Time, we need some extra time to confirm. Look for an email from us soon letting you know you’re set!</span>
        </>);
    else
        title = (<>
            <h1 className="page-header">Congratulations!</h1>
            <span className="page-subheader text-xl">Setup is complete</span>
        </>);

    return (

        <div className="page-content-wrapper gap-y-5">
            <Congratulations className="h-60" />
            {title}
            <div className="w-4/5">
                {body}
            </div>
            <div className="page-action">
                <button type="button" className="btn btn-primary text-xl font-semibold rounded-full" onClick={next}>Save and Finish</button>
            </div>

        </div >
    );

};

export default EnrollmentCompleted;
